import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Dialog from 'react-toolbox/lib/dialog';
import moment from 'moment';
import MembershipCard from './index';
import { getCustomer } from '../../selectors/customers';
import { getOrganization } from '../../selectors/organizations';
import { getCurrentUser } from '../../../../redux-modules/current-user';
import styles from './MembershipCardModal.css';

class MembershipCardModal extends React.Component {
  static propTypes = {
    active: PropTypes.bool,
    toggleActive: PropTypes.func,
    currentOrganization: PropTypes.shape({
      id: PropTypes.number,
      organizationDetails: PropTypes.shape({
        name: PropTypes.string,
      }),
      membershipDetails: PropTypes.shape({
        originalJoinDate: PropTypes.string,
      }),
    }),
  };

  handleClose = () => {
    this.props.toggleActive();
  };

  render() {
    const {
      id,
      organizationDetails: { name } = {},
      membershipDetails: { originalJoinDate } = {},
    } =
      this.props.currentOrganization || {};
    return (
      <Dialog
        active={this.props.active}
        onEscKeyDown={this.handleClose}
        onOverlayClick={this.handleClose}
        theme={{ dialog: styles.dialog, body: styles.dialogBody }}
      >
        <MembershipCard
          businessName={name}
          memberId={id}
          memberSince={moment(originalJoinDate).format('MM/DD/YYYY')}
        />
        <span className={styles.closeIcon} onClick={this.handleClose}>
          <i className="material-icons">clear</i>
        </span>
      </Dialog>
    );
  }
}

const mapStateToProps = state => {
  const currentUser = getCurrentUser(state);
  const currentCustomer = getCustomer(state, { id: currentUser.id });
  let currentOrganization;
  if (
    currentCustomer &&
    currentCustomer.organization &&
    currentCustomer.organization.key
  ) {
    currentOrganization = getOrganization(state, {
      id: currentCustomer.organization.key,
    });
  }
  return {
    currentOrganization,
  };
};

export default connect(mapStateToProps)(MembershipCardModal);



// WEBPACK FOOTER //
// ./src/App/account/components/MembershipCard/Modal.js